import heroBg from "../images/hero-bg.jpg";

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src={heroBg}
          alt="Kadernícky salón pozadie"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Krása začína
          <br />
          starostlivosťou
        </h1>

        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Profesionálne kadernícke služby s individuálnym prístupom. Vytvoríme pre
          vás dokonalý vzhľad, ktorý podčiarkne vašu jedinečnosť.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection("kontakt")}
            className="bg-amber-700 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-amber-800 transition-all hover:scale-105 whitespace-nowrap"
          >
            Objednať sa
          </button>

          <button
            onClick={() => scrollToSection("kontakt")}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap"
          >
            Kontakt
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection("sluzby")}
          className="text-white/80 hover:text-white transition-colors"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
